import { useEffect, useRef, useState } from 'react';

export default function GuidedTrainingOverlay({title, explanation, why, targetId, progress, onBack, onPause, onExit, busy, error}) {
  const overlayRef = useRef();
  const [targetError, setTargetError] = useState('');

  useEffect(() => {
    const target = document.getElementById(targetId);
    if (!target) {
      setTargetError('The required training control is unavailable. Retry after reloading the workspace; progress has not advanced.');
      overlayRef.current?.focus();
      return;
    }
    setTargetError('');
    target.setAttribute('aria-describedby', 'training-overlay-description');
    target.focus({ preventScroll: true });
    return () => target.removeAttribute('aria-describedby');
  }, [targetId, title]);

  return <aside ref={overlayRef} tabIndex="-1" className="demo-training-overlay" role="dialog" aria-modal="false" aria-labelledby="training-overlay-title" aria-describedby="training-overlay-description" data-target={targetId} onKeyDown={event => { if (event.key === 'Escape' && !busy) onPause(); }}>
    <div className="d-flex justify-content-between gap-3"><span className="badge bg-primary">Training step {progress.current} of {progress.total}</span><button className="btn-close" aria-label="Pause guided training" onClick={onPause}/></div>
    <h2 className="h5 mt-3" id="training-overlay-title">{title}</h2>
    <p id="training-overlay-description">{explanation}</p>
    {why && <details><summary>Why this matters</summary><p className="mt-2">{why}</p></details>}
    {(error || targetError) && <p className="text-danger" role="alert">{error || targetError}</p>}
    <div className="progress my-3" role="progressbar" aria-label="Training progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow={Math.round(progress.current/progress.total*100)}><div className="progress-bar" style={{width:`${progress.current/progress.total*100}%`}} /></div>
    <div className="d-flex flex-wrap gap-2"><button className="btn btn-sm btn-outline-dark" disabled={busy||progress.current===1} onClick={onBack}>Back</button><button className="btn btn-sm btn-outline-dark" disabled={busy} onClick={onPause}>Pause tour</button><button className="btn btn-sm btn-link" disabled={busy} onClick={onExit}>Exit to dashboard</button></div>
  </aside>;
}
